import type {
  DirectInterline,
  DirectInterlineApi,
  DirectInterlineFilters,
  DirectInterlineFiltersUpdateApi,
  DirectInterlines,
  DirectInterlinesApi,
} from '../../models';
import { inlineSearch, paginate } from '../normalize';

export const normalizeDirectInterline = (directInterline: DirectInterlineApi): DirectInterline => ({
  ...directInterline,
  label: directInterline.codeDesc,
});

export const normalizeDirectInterlines = (response: DirectInterlinesApi): DirectInterlines => {
  const list = (response.items ?? [])
    .sort((a, b) => a.codeDesc.localeCompare(b.codeDesc))
    .map(normalizeDirectInterline);

  return {
    list,
    map: list.reduce(
      (acc, directInterline) => {
        acc[String(directInterline.id)] = directInterline;
        return acc;
      },
      {} as DirectInterlines['map'],
    ),
  };
};

export const normalizeDirectInterlineFilters = (
  filters: Partial<DirectInterlineFilters>,
): DirectInterlineFiltersUpdateApi => {
  const { search, ...otherFilters } = filters;
  return {
    ...inlineSearch(search),
    ...inlineSearch(otherFilters),
    ...paginate(otherFilters),
    Sorting: 'codeDesc asc',
  };
};
